import Phaser from 'phaser';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload() {
    // 로딩 바 구현
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;

    const progressBar = this.add.graphics();
    const progressBox = this.add.graphics();
    progressBox.fillStyle(0x222222, 0.8);
    progressBox.fillRect(width / 2 - 160, height / 2 - 25, 320, 50);

    const loadingText = this.add.text(width / 2, height / 2 - 50, 'Loading...', {
      font: '20px monospace',
      color: '#ffffff'
    });
    loadingText.setOrigin(0.5, 0.5);

    this.load.on('progress', (value: number) => {
      progressBar.clear();
      progressBar.fillStyle(0xffffff, 1);
      progressBar.fillRect(width / 2 - 150, height / 2 - 15, 300 * value, 30);
    });

    this.load.on('complete', () => {
      progressBar.destroy();
      progressBox.destroy();
      loadingText.destroy();
    });

    this.load.audio('lobby_bgm', '/assets/audio/lobby_bgm.wav');
    this.load.audio('game_bgm', '/assets/audio/game_bgm.wav');
    this.load.audio('button_click', '/assets/audio/button_click.wav');
    this.load.audio('kill', '/assets/audio/kill.wav');
    this.load.audio('conquer', '/assets/audio/conquer.wav');
    this.load.audio('death', '/assets/audio/death.wav');
    this.load.audio('warning', '/assets/audio/warning.wav');
    this.load.audio('rank_up', '/assets/audio/rank_up.wav');
    this.load.image('lobby-casual-bg', '/assets/lobby-casual-bg.png');
  }

  create() {
    const params = new URLSearchParams(window.location.search);
    const localGameTestEnabled = import.meta.env.VITE_ENABLE_LOCAL_GAME_TEST === 'true';

    if (localGameTestEnabled && params.get('localGame') === '1') {
      console.log('Starting local GameScene test mode');
      this.scene.start('GameScene', {
        nickname: 'Local Test',
        roomId: 'local-test-room',
        playerId: 'local-test-player',
        spawnPosition: { x: 50, y: 50 },
        color: '#4D96FF',
        players: [],
        offline: true,
      });
      return;
    }

    // 로딩 완료 후 바로 로비로 이동
    this.scene.start('LobbyScene');
  }
}
